export { patchGlobalConsole, unpatchGlobalConsole } from '../chunk-AL3JR7GX.js';
import '../chunk-P3UGCU6L.js';
import '../chunk-QVZ6GPFP.js';
import '../chunk-4IHYJA4S.js';
//# sourceMappingURL=patch-console.js.map
//# sourceMappingURL=patch-console.js.map